// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2645w","placeholdersHeader":"styles_placeholdersHeader__1uUJn","editorStyle":"styles_editorStyle__1T4va","placeholdersBox":"styles_placeholdersBox__11YWR"};